import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

// Import navigation elements
import { navigation } from '../../_nav';

@Component({
  selector: 'app-sidebar-nav',
  template: `
    <nav class="sidebar-nav">
      <ul class="nav">
        <ng-template ngFor let-navitem [ngForOf]="navigation">
          <li *ngIf="isDivider(navitem)" class="nav-divider"></li>
          <ng-template [ngIf]="isTitle(navitem)">
            <app-sidebar-nav-title [title]='navitem'></app-sidebar-nav-title>
          </ng-template>
          <ng-template [ngIf]="!isDivider(navitem)&&!isTitle(navitem)">
            <app-sidebar-nav-item [item]='navitem'></app-sidebar-nav-item>
          </ng-template>
        </ng-template>
      </ul>
    </nav>`
})
export class AppSidebarNavComponent {

  public navigation = navigation;

  public isDivider(item) {
    return item.divider ? true : false
  }

  public isTitle(item) {
    return item.title ? true : false
  }

  constructor() { }
}

import { Router } from '@angular/router';

@Component({
  selector: 'app-sidebar-nav-item',
  template: `
    <li *ngIf="!isDropdown(); else dropdown" [ngClass]="hasClass() ? 'nav-item ' + item.class : 'nav-item'">
      <app-sidebar-nav-link [link]='item'></app-sidebar-nav-link>
    </li>
    <ng-template #dropdown>
      <li [ngClass]="hasClass() ? 'nav-item nav-dropdown ' + item.class : 'nav-item nav-dropdown'"
          [class.open]="isActive()"
          routerLinkActive="open"
          appNavDropdown>
        <app-sidebar-nav-dropdown [link]='item'></app-sidebar-nav-dropdown>
      </li>
    </ng-template>
    `
})
export class AppSidebarNavItemComponent {
  @Input() item: any;

  public hasClass() {
    return this.item.class ? true : false
  }

  public isDropdown() {
    return this.item.children ? true : false
  }

  public thisUrl() {
    return this.item.url
  }

  public isActive() {
    return this.router.isActive(this.thisUrl(), false)
  }

  constructor(private router: Router) { }

}

import { StorageService } from './../../globals/storage';

@Component({
  //Submenu 
  selector: 'app-sidebar-nav-link',
  template: `
    <a *ngIf="isAllowed()"
      [ngClass]="hasVariant() ? 'nav-link nav-link-' + link.variant : 'nav-link'"
      routerLinkActive="active"
      [routerLink]="[link.url]">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>   
  `
})
export class AppSidebarNavLinkComponent {
  @Input() link: any;

  rules: any;

  public hasVariant() {
    return this.link.variant ? true : false
  }

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isAllowed() {
   
    let allowed: boolean;
    if (this.link.permissao == "empresas") {
      allowed = this.rules.empresas.menu == 1 ? true : false;
    } else if (this.link.permissao == "grupos") {
      allowed = this.rules.grupos.menu == 1 ? true : false;
    } else if (this.link.permissao == "rotinas") {
      allowed = this.rules.rotinas.menu == 1 ? true : false;
    } else if (this.link.permissao == "necessidades") {
      allowed = this.rules.necessidades.menu == 1 ? true : false;
    } else if (this.link.permissao == "nocoes") {
      allowed = this.rules.nocoes.menu == 1 ? true : false;
    } else if (this.link.permissao == "escolas") {
      allowed = this.rules.escolas.menu == 1 ? true : false;
    } else if (this.link.permissao == "parceiros") {
      allowed = this.rules.parceiros.menu == 1 ? true : false;
    } else if (this.link.permissao == "voluntarios") {
      allowed = this.rules.voluntarios.menu == 1 ? true : false;
   
    } else if (this.link.permissao == "usuarios") {
      allowed = this.rules.usuarios.menu == 1 ? true : false;
   
    } else if (this.link.permissao == "projetos") {
      allowed = this.rules.projetos.menu == 1 ? true : false;
    } else if (this.link.permissao == "cargos") {
      allowed = this.rules.cargos.menu == 1 ? true : false;
    } else if (this.link.permissao == "conselhos") {
      allowed = this.rules.conselhos.menu == 1 ? true : false;
    } else if (this.link.permissao == "diretorias") {
      allowed = this.rules.diretorias.menu == 1 ? true : false;
    } else if (this.link.permissao == "reservas") {
      allowed = this.rules.reservas.menu == 1 ? true : false;
    } else if (this.link.permissao == "editoras") {
      allowed = this.rules.editoras.menu == 1 ? true : false;
    } else if (this.link.permissao == "autores") {
      allowed = this.rules.autores.menu == 1 ? true : false;
    }else if (this.link.permissao == "leitores") {
      allowed = this.rules.leitores.menu == 1 ? true : false;
    }else if (this.link.permissao == "funcionarios") {
      allowed = this.rules.funcionarios.menu == 1 ? true : false;
    }else if (this.link.permissao == "livros") {
      allowed = this.rules.livros.menu == 1 ? true : false;
    } else if (this.link.permissao == "idiomas") {
      allowed = this.rules.idiomas.menu == 1 ? true : false;
    } else if (this.link.permissao == "categoriasBiblioteca") {
      allowed = this.rules.categoriasBiblioteca.menu == 1 ? true : false;
    } else if (this.link.permissao == "gerenciarCursos") {
      allowed = this.rules.gerenciarCursos.menu == 1 ? true : false;
    } else if (this.link.permissao == "alunos") {
      allowed = this.rules.alunos.menu == 1 ? true : false;
    } else if (this.link.permissao == "modulos") {
      allowed = this.rules.modulos.menu == 1 ? true : false;
    } else if (this.link.permissao == "turmas") {
      allowed = this.rules.turmas.menu == 1 ? true : false;
    } else if (this.link.permissao == "notasAluno") {
      allowed = this.rules.notasAluno.menu == 1 ? true : false;
    } else if (this.link.permissao == "notasProfessor") {
      allowed = this.rules.notasProfessor.menu == 1 ? true : false;
    } else if (this.link.permissao == "frequenciaProfessor") {
      allowed = this.rules.frequenciaProfessor.menu == 1 ? true : false;
    } else if (this.link.permissao == "frequenciaAluno") {
      allowed = this.rules.frequenciaAluno.menu == 1 ? true : false;
    }  else if (this.link.permissao == "categoriasCursos") {
      allowed = this.rules.categoriasCursos.menu == 1 ? true : false;
    } else if (this.link.permissao == "gerenciarEventos") {
      allowed = this.rules.gerenciarEventos.menu == 1 ? true : false;
    } else if (this.link.permissao == "inscrever") {
      allowed = this.rules.inscrever.menu == 1 ? true : false;
    } else if (this.link.permissao == "categoriasEventos") {
      allowed = this.rules.categoriasEventos.menu == 1 ? true : false;
    } else if (this.link.permissao == "publicacoes") {
      allowed = this.rules.publicacoes.menu == 1 ? true : false;
    }else if (this.link.permissao == "turmasFinalizadas") {
      allowed = this.rules.turmasFinalizadas.menu == 1 ? true : false;
    }else if (this.link.permissao == "site") {
      allowed = this.rules.site.menu == 1 ? true : false;
    }else if (this.link.permissao == "patrocinadores") {
      allowed = this.rules.site.menu == 1 ? true : false;
    } else if (this.link.permissao == "processoSeletivo") {
      allowed = this.rules.inscricoes.menu == 1 ? true : false;
    }
    return allowed; 
   //return true;
  }
  public isIcon() {
    return this.link.icon ? true : false
  }

  constructor(private _StorageService: StorageService) {
    this.rules = JSON.parse(this._StorageService.getItem('acl_rules'));
  }
}



@Component({
  //Menu Principal
  selector: 'app-sidebar-nav-dropdown',
  template: `
    <a class="nav-link nav-dropdown-toggle" appNavDropdownToggle *ngIf="isAllowed()">
      <i *ngIf="isIcon()" class="{{ link.icon }}"></i>
      {{ link.name }}
      <span *ngIf="isBadge()" [ngClass]="'badge badge-' + link.badge.variant">{{ link.badge.text }}</span>
    </a>
    <ul class="nav-dropdown-items">
      <ng-template ngFor let-child [ngForOf]="link.children">
        <app-sidebar-nav-item [item]='child'></app-sidebar-nav-item>
      </ng-template>
    </ul>
  `
})
export class AppSidebarNavDropdownComponent {
  @Input() link: any;

  rules: any;

  public isBadge() {
    return this.link.badge ? true : false
  }

  public isIcon() {
    return this.link.icon ? true : false
  }


  public isAllowed() {
    let allowed: boolean;
    if (this.link.permissao == "configuracoes") {
      allowed = this.rules.configuracoes.menu == 1 ? true : false;
    } else if (this.link.permissao == "administracao") {
      allowed = this.rules.administracao.menu == 1 ? true : false;
    } else if (this.link.permissao == "biblioteca") {
      allowed = this.rules.biblioteca.menu == 1 ? true : false;
    } else if (this.link.permissao == "cursos") {
      allowed = this.rules.cursos.menu == 1 ? true : false;
    } else if (this.link.permissao == "eventos") {
      allowed = this.rules.eventos.menu == 1 ? true : false;
    } else if (this.link.permissao == "blog") {
      allowed = this.rules.blog.menu == 1 ? true : false;
    } else if (this.link.permissao == "processoSeletivo") {
      allowed = this.rules.processoSeletivo.menu == 1 ? true : false;
    }
    return allowed; 
    //return true;
  }

  constructor(private _StorageService: StorageService) {
    this.rules = JSON.parse(this._StorageService.getItem('acl_rules'));
  }

}

@Component({
  selector: 'app-sidebar-nav-title',
  template: ''
})
export class AppSidebarNavTitleComponent implements OnInit {
  @Input() title: any;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    const nativeElement: HTMLElement = this.el.nativeElement;
    const li = this.renderer.createElement('li');
    const name = this.renderer.createText(this.title.name);

    this.renderer.addClass(li, 'nav-title');

    if (this.title.class) {
      const classes = this.title.class;
      this.renderer.addClass(li, classes);
    }

    if (this.title.wrapper) {
      const wrapper = this.renderer.createElement(this.title.wrapper.element);

      this.renderer.appendChild(wrapper, name);
      this.renderer.appendChild(li, wrapper);
    } else {
      this.renderer.appendChild(li, name);
    }
    this.renderer.appendChild(nativeElement, li)
  }
}

export const APP_SIDEBAR_NAV = [
  AppSidebarNavComponent,
  AppSidebarNavDropdownComponent,
  AppSidebarNavItemComponent,
  AppSidebarNavLinkComponent,
  AppSidebarNavTitleComponent
];



// WEBPACK FOOTER //
// ./src/app/shared/app-sidebar-nav/app-sidebar-nav.component.ts